var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row no-gutters align-items-center fd-level-bar"},[(_vm.label)?_c('div',{staticClass:"col-7"},[_c('FdText',{staticClass:"fd-level-bar__label",attrs:{"tag":"span"}},[_vm._v(_vm._s(_vm.label))])],1):_vm._e(),_c('div',{class:['col', { 'pl-2': _vm.label }]},[_c('div',{staticClass:"d-flex overflow-hidden fd-level-bar__bar-wrapper w-100 rounded-1"},[_c('div',{staticClass:"fd-level-bar__bar",style:({
          width: _vm.percentage + '%',
          backgroundColor: _vm.color,
        })})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }